import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiLock, FiAward } = FiIcons;

const Hero = () => {
  return (
    <section className="relative bg-slate-900 pt-32 pb-20 lg:pt-40 lg:pb-32 overflow-hidden">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-1/2 -right-1/4 w-[1000px] h-[1000px] rounded-full bg-slate-800 opacity-50 blur-3xl"></div>
        <div className="absolute -bottom-1/2 -left-1/4 w-[800px] h-[800px] rounded-full bg-yellow-900 opacity-20 blur-3xl"></div>
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-slate-800 border border-slate-700 text-yellow-400 text-sm font-bold mb-8 shadow-[0_0_15px_rgba(234,179,8,0.2)]">
          <SafeIcon icon={FiAward} />
          <span>#1 Rated Precious Metals Resource</span>
        </div>
        
        <h1 className="text-4xl md:text-5xl lg:text-7xl font-bold text-white mb-6 leading-tight font-serif">
          Interactive <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-300 to-yellow-600">Gold IRA Calculator</span>
        </h1>
        
        <p className="max-w-3xl mx-auto text-lg md:text-xl text-slate-100 mb-12 leading-relaxed font-medium">
          Project the future value of your retirement portfolio and stress-test your strategy against historical market crashes. Learn why physical gold is the preferred hedge of institutional investors.
        </p>
        
        <div className="flex flex-col sm:flex-row justify-center items-center gap-6">
          <a 
            href="#gold-ira-calculator"
            className="inline-flex items-center justify-center px-10 py-5 text-xl font-bold text-slate-900 transition-all duration-200 bg-gradient-to-r from-yellow-400 to-yellow-500 rounded-xl shadow-lg hover:from-yellow-300 hover:to-yellow-400 hover:scale-105 w-full sm:w-auto"
          >
            Start Projecting Now
          </a>
          <div className="flex items-center gap-2 text-slate-300 text-sm font-bold uppercase tracking-wider">
            <SafeIcon icon={FiLock} className="text-green-400" />
            <span>100% Free & Secure Tools</span>
          </div>
        </div>
        
        <div className="mt-20 pt-10 border-t border-slate-800/60 grid grid-cols-2 md:grid-cols-4 gap-8 opacity-80 grayscale hover:grayscale-0 transition-all">
          <span className="text-white font-serif font-bold text-2xl">Forbes</span>
          <span className="text-white font-serif font-bold text-2xl">Bloomberg</span>
          <span className="text-white font-sans font-bold text-2xl tracking-tighter">TechCrunch</span>
          <span className="text-white font-serif italic text-2xl">WSJ</span>
        </div>
      </div>
    </section>
  );
};

export default Hero;